import React from "react";

function IndustryChallenges({ challenges }) {
  return (
    <section
      style={{
        padding: "100px 20px",
        background: "#ffffff",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            color: "#002147",
            marginBottom: "40px",
            textAlign: "center",
          }}
        >
          Key Industry Challenges
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(280px,1fr))",
            gap: "24px",
          }}
        >
          {challenges.map((challenge) => (
            <div
              key={challenge}
              className="premium-card"
              style={{
                padding: "30px",
              }}
            >
              <div
                style={{
                  color: "#002147",
                  fontWeight: 600,
                  lineHeight: 1.8,
                }}
              >
                {challenge}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustryChallenges;